<button class="button-icon" [ngClass]="design" [disabled]="disabled" (click)="buttonClicked.emit()">
    <app-icons *ngIf="icon && icon !== '' && !icon.includes('right')" [design]="icon"></app-icons>
    <ng-content></ng-content>
    <app-icons *ngIf="icon && icon !== '' && icon.includes('right')" [design]="icon"></app-icons>
    <app-badge *ngIf="badge">{{ badge }}</app-badge>
</button>
